import CompetencyAssessmentPage from "../components/competencyAssessment/main";

const CompetencyAssessment = () => {
  return <CompetencyAssessmentPage />;
};

export default CompetencyAssessment;
